import { useQuery } from 'react-query';

// Services.
import { getCertMasterPlatformHighestRole } from 'services';
import { useProfile } from './useProfile';
import { CertMasterPlatformRole } from '@comptia-sso/core';

type UseCertMasterPlatformHighestRole = [CertMasterPlatformRole];

export const useCertMasterPlatformHighestRole = (
  profileId?: string,
): UseCertMasterPlatformHighestRole => {
  const profile = useProfile();

  const pidToUse = profileId ?? profile[0]?.id;
  const { data } = useQuery<string>(
    `certmasterplatformhighestrole-${pidToUse}`,
    () => {
      if (!pidToUse) return CertMasterPlatformRole.None;
      return getCertMasterPlatformHighestRole(pidToUse);
    },
  );

  return [data as CertMasterPlatformRole];
};
